<div class="content">
    <div class="form" *ngFor="let page of pageDetails">
        <h1>{{page.name}}</h1>
        <div class="content">
            <angular-editor type="text" name="description" [(ngModel)]="page.content_description" [config]="editorConfig"></angular-editor>
        </div>
    </div>
</div>

